import { Component, OnDestroy } from '@angular/core';
import { ModalController, ViewController } from 'ionic-angular';
import { Subject } from 'rxjs';

import { FillerShiftModel } from '../../models/filler-shift';
import { LoadingAlertProvider } from '../../providers/loading-alert/loading-alert';
import { OpsProvider } from '../../providers/ops/ops';
import { TruckModel } from '../../models/truck';
import { TrucksPage } from '../trucks/trucks';
import { UserModel } from '../../models/user';
import { UserProvider } from '../../providers/user/user';


@Component({
  selector: 'page-shift',
  templateUrl: 'shift.html',
})
export class ShiftPage implements OnDestroy {
  static readonly BG_LOCATION_INTERVAL_KEY = 'bgLocationIntervalKEY';
  user: UserModel;
  selectedTruck: TruckModel;
  trucks: TruckModel[];
  isLoading = true;
  currentFillerShift: FillerShiftModel;

  handbookUrl =
    'https://drive.google.com/file/d/13BluuS3xMJTLKIs6PN9HqE5XFpk6CZPX';

  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private userProvider: UserProvider,
    private opsService: OpsProvider,
    private loadingAlert: LoadingAlertProvider,
    private modalCtrl: ModalController,
    private viewCtlr: ViewController
  ) {
    this.userProvider.currentUser$
      .takeUntil(this.unsubscribe)
      .subscribe(user => (this.user = user));
    this.userProvider.currentFillerShift$
      .takeUntil(this.unsubscribe)
      .subscribe(shift => (this.currentFillerShift = shift));
    this.opsService.selectedTruck$
      .takeUntil(this.unsubscribe)
      .subscribe((truck: TruckModel) => (this.selectedTruck = truck));
    this.opsService.loadSelectedTruck();
    this.userProvider.getCurrentFillerShift();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ShiftPage');
  }

  didSelectTruck(truck: TruckModel) {
    this.opsService.setSelectedTruck(truck);
  }

  didTapDismiss() {
    this.viewCtlr.dismiss();
  }

  didTapStartShift() {
    this.loadingAlert.showLoader();
    this.opsService.startShift(this.selectedTruck).subscribe(
      () => {
        this.loadingAlert.dismissLoader();
        this.viewCtlr.dismiss();
        this.userProvider.getCurrentFillerShift();
      },
      error => {
        this.loadingAlert.dismissLoader();
        this.loadingAlert.showToastAlert('Error starting shift: ' + error);
      }
    );
  }

  didTapEndShift() {
    this.loadingAlert.showLoader();
    if (!this.currentFillerShift) {
      return;
    }
    this.opsService.endShift(this.currentFillerShift).subscribe(
      () => {
        this.loadingAlert.dismissLoader();
        this.viewCtlr.dismiss();
        this.userProvider.getCurrentFillerShift();
      },
      error => {
        this.loadingAlert.dismissLoader();
        this.loadingAlert.showToastAlert('Error ending shift');
      }
    );
  }

  didTapSelectTruck() {
    if (!this.currentFillerShift) {
      // disallow changing truck if shift is active.
      this.modalCtrl.create(TrucksPage, { isModal: true }).present();
    }
  }

  // Helper

  isTruckSelected(truck: TruckModel) {
    return truck && this.selectedTruck && truck.uid == this.selectedTruck.uid;
  }

}



// WEBPACK FOOTER //
// ./src/pages/shift/shift.ts